import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { IRecentActivity } from 'models/user/recentactivity';
import { RecentActivityType } from 'models/enums/recentactivitytype';
import * as moment from 'moment';
import { imgSrcAttributes } from 'helpers/common';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IRecentActivity;
	activityLikesVisible?: boolean;
	activityCommentsVisible?: boolean;
	activityStylesVisible?: boolean;
	activityWishlistVisible?: boolean;
	activityArticlesVisible?: boolean;
	activityFollowsVisible?: boolean;
	activityWardrobeItemsVisible?: boolean;
	activityOutfitsVisible?: boolean;
	userPicture?: string;
	setDefaultUserShippingAddress?: (addressId: string) => void;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserRecentActivityItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
	}

	private goToCard(e: any) {
		e.preventDefault();
		if (this.props.goToCard) {
			this.props.goToCard(JSON.parse(this.props.item.node.entityId).id, this.props.item.recentActivityType);
		}
	}

	private formatActivityText(resource: string, name) {
		const regex = new RegExp(/\[\[name\]\]/);

		return (
			<div className="title">
				{resource.split(regex).reduce((prev, current, i) => {
					if (!i) {
						return [current];
					}

					const element = (
						<a key={i} href="#" onClick={this.goToCard}>
							{name}
						</a>
					);

					return prev.concat([element, current]);
				}, [])}
			</div>
		);
	}

	public render() {
		const {
			t,
			userPicture,
			activityArticlesVisible,
			activityFollowsVisible,
			activityLikesVisible,
			activityWardrobeItemsVisible,
			activityWishlistVisible,
			activityOutfitsVisible,
			item,
		} = this.props;

		let picture = userPicture;
		if (!picture) {
			picture = require('containers/Html/images/defaultUser.svg');
		}

		let resource = null;
		let activityDisplayed: boolean = false;
		let displayImage: boolean = false;
		switch (item.recentActivityType) {
			case RecentActivityType.AddArticle:
				resource = t('User_UserCard_Tabs_Activity_Text_PostedNewArticle');
				activityDisplayed = activityArticlesVisible;
				break;

			case RecentActivityType.AddWardrobeItem:
				resource = t('User_UserCard_Tabs_Activity_Text_CreatedNewWardrobeItem');
				activityDisplayed = activityWardrobeItemsVisible;
				displayImage = true;
				break;

			case RecentActivityType.AddWishlistProduct:
				resource = t('User_UserCard_Tabs_Activity_Text_AddedNewProductToWishlist');
				activityDisplayed = activityWishlistVisible;
				displayImage = true;
				break;

			case RecentActivityType.AddWishlistWardrobeItem:
				resource = t('User_UserCard_Tabs_Activity_Text_AddedNewWardrobeItemToWishlist');
				activityDisplayed = activityWishlistVisible;
				displayImage = true;
				break;

			case RecentActivityType.FollowUser:
				resource = t('User_UserCard_Tabs_Activity_Text_StartedFollowingUser');
				activityDisplayed = activityFollowsVisible;
				break;

			case RecentActivityType.LikeArticle:
				resource = t('User_UserCard_Tabs_Activity_Text_LikedMagazineArticle');
				activityDisplayed = activityLikesVisible;
				break;

			case RecentActivityType.LikeProduct:
				resource = t('User_UserCard_Tabs_Activity_Text_LikedProduct');
				activityDisplayed = activityLikesVisible;
				displayImage = true;
				break;

			case RecentActivityType.AddOutfit:
				resource = t('User_UserCard_Tabs_Activity_Text_CreatedNewOutfit');
				activityDisplayed = activityOutfitsVisible;
				break;

			default:
				resource = '';
				break;
		}

		return (
			<div className={`userRecentActivityItemCard ${!displayImage ? 'activityCardWithoutImage' : ''}`}>
				<div>
					<div className="activityFirstRow">
						<div className="profileImage">
							<img {...imgSrcAttributes(picture)} />
						</div>
						{this.formatActivityText(resource, item.node.name)}
						<div className="date">{moment.utc(item.node.addedDate).fromNow()}</div>
					</div>
					{displayImage ? (
						<div className="imagesWrapper">
							<img {...imgSrcAttributes(item.node.picture)} />
						</div>
					) : null}
				</div>
				{this.props.isMyProfile ? (
					<div className="vissibleIcon">
						{activityDisplayed ? (
							<div>
								<img src={`${require('containers/Html/icons/eye-visible.svg')}`} />
							</div>
						) : (
							<div>
								<img src={`${require('containers/Html/icons/eye-novisible.svg')}`} />
							</div>
						)}
					</div>
				) : null}
			</div>
		);
	}
}

export { UserRecentActivityItemCard };
